export default __webpack_public_path__ + "static/media/082209_0457.6f3c425c.jpg";